import { ReactElement } from 'react';

export function ChevronRightIcon(): ReactElement {
  return (
    <svg fill='#757575' height='10' width='6' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.896 5c0 .293-.116.574-.323.781L1.597 9.757A.737.737 0 01.556 8.715l3.641-3.641a.104.104 0 000-.148L.556 1.285A.737.737 0 011.597.243L5.573 4.22c.207.207.323.488.323.78z' />
    </svg>
  );
}
